import { render, staticRenderFns } from "./OpenTableModalButton.vue?vue&type=template&id=525ebcfd&scoped=true&"
import script from "./OpenTableModalButton.vue?vue&type=script&lang=ts&"
export * from "./OpenTableModalButton.vue?vue&type=script&lang=ts&"
import style0 from "./OpenTableModalButton.vue?vue&type=style&index=0&id=525ebcfd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525ebcfd",
  null
  
)

export default component.exports